// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OcObg{display:flex;align-items:center;justify-content:space-between;inline-size:100%}.OcObg:not(:empty){padding-block:12px}.uYQiF{flex:1 1 auto;min-inline-size:0}.sOVQp{margin-inline-start:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OcObg`,
	"header": `uYQiF`,
	"actions": `sOVQp`
};
export default ___CSS_LOADER_EXPORT___;
